import { Path } from "paths";
import { generatePath } from "react-router-dom";
import { FastTagPage } from "../FastTagPage";
import { UnknownPage } from "../FastTagPage/UnknownPage";

export const fastTagDetailPath = (page: FastTagPage | UnknownPage) =>
  generatePath(Path.fastTagDetail, { program: page.fastTag });
